import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { withDashboardContext, withRouter } from '@stackhouse/dashboard-components/Dashboard'

import GridPage from './grid'
import DownloadWithProgress from '../modals/downloadProgress'


class AttachmentTemplate extends PureComponent {

    static propTypes = {
        /** Inherited Grid Template PropTypes */
        ...GridPage.propTypes,
        /** Form name (document parent collection) */
        formName: PropTypes.string,
    }

    onDoubleClickRow = ({ idDocument, fileName }) => {
        return DownloadWithProgress({ url: `/attachment/${idDocument}/download`, fileName })
    }

    render() {
        const { formName, resourceId } = this.props
        return (
            <GridPage
                functionName={'attachments'}
                rowsEndpoint={`/attachment/${formName}/${resourceId}`}
                {...this.props}
                onDoubleClickRow={this.onDoubleClickRow}
            />
        )
    }
}


export default withDashboardContext(withRouter(AttachmentTemplate), ({ client, withLoader }) => ({ client, withLoader }))
